module.exports = __webpack_public_path__ + "static/s-exam2-d95ecc52e06a0a099685ee8c4cb535f7.png";